module.exports = __webpack_public_path__ + "img/logo3.9ba25b2d.png";